"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textToElement = exports.tag = exports.img = exports.hr = exports.br = exports.div = exports.a = exports.p = exports.span = exports.addSpace = exports.addText = exports.addAttrs = void 0;
function addAttrs(el, attrs) { if (!attrs)
    return; for (const attr in attrs) {
    el.setAttribute(attr, attrs[attr]);
} }
exports.addAttrs = addAttrs;
function addText(el, text) { el.appendChild(document.createTextNode(text)); }
exports.addText = addText;
;
function addSpace(el) { el.appendChild(document.createTextNode(' ')); }
exports.addSpace = addSpace;
function createAndFillElement(tag, inner = "", attrs = {}) {
    const el = document.createElement(tag);
    el.innerHTML = inner;
    addAttrs(el, attrs);
    return el;
}
function span(attrs = {}, inner = "") { return createAndFillElement('span', inner, attrs); }
exports.span = span;
;
function p(attrs = {}, inner = "") { return createAndFillElement('p', inner, attrs); }
exports.p = p;
;
function a(attrs = {}, inner = "") { return createAndFillElement('a', inner, attrs); }
exports.a = a;
;
function div(attrs = {}, inner = "") { return createAndFillElement('div', inner, attrs); }
exports.div = div;
;
function br(attrs = {}) { const el = document.createElement('br'); addAttrs(el, attrs); return el; }
exports.br = br;
;
function hr(attrs = {}) { const el = document.createElement('hr'); addAttrs(el, attrs); return el; }
exports.hr = hr;
;
function img(attrs = {}) { const el = document.createElement('img'); addAttrs(el, attrs); return el; }
exports.img = img;
;
function tag(tagName, attrs = {}, inner = '') { const el = document.createElement(tagName); addAttrs(el, attrs); el.innerHTML = inner; return el; }
exports.tag = tag;
;
function textToElement(text) {
    return div({}, text).firstElementChild;
}
exports.textToElement = textToElement;
//# sourceMappingURL=html.js.map